import { useEffect, useRef } from 'react';
import { FEELINGS, momentRef, pathById } from '../../data';
import { usePrefs } from '../hooks';
import { requestPlay } from '../intent';
import { PatternsTabs } from './Paths';

export function Feelings({ focus }: { focus?: string }) {
  const { prefs } = usePrefs();
  const named = prefs.depth >= 2;
  const refs = useRef<Record<string, HTMLDivElement | null>>({});
  useEffect(() => {
    if (focus) refs.current[focus]?.scrollIntoView({ block: 'center' });
  }, [focus]);
  return (
    <div>
      <header className="page-head">
        <span className="label">Patterns</span>
        <h1>Listen by feeling</h1>
        <p>Start from what you hear, in your own words. Each feeling leads to moments where it happens and to the patterns that produce it.</p>
      </header>
      <PatternsTabs current="feel" />
      <div className="feelings">
        {FEELINGS.map((f) => {
          const moments = f.moments.map(momentRef).filter(Boolean) as Array<NonNullable<ReturnType<typeof momentRef>>>;
          const paths = f.paths.map(pathById).filter(Boolean);
          return (
            <div
              key={f.id}
              className="feeling"
              id={`feel-${f.id}`}
              ref={(el) => {
                refs.current[f.id] = el;
              }}
              style={focus === f.id ? { background: 'var(--rest-wash)', paddingInline: 12, borderRadius: 8 } : undefined}
            >
              <div className="word">
                {f.phrase}
                <small>{f.word}</small>
              </div>
              <div className="chips" style={{ alignContent: 'flex-start' }}>
                {moments.map(({ piece, moment }) => (
                  <a key={`${piece.id}-${moment.id}`} className="chip" href={`#${piece.id}.${moment.id}`} onClick={() => requestPlay(piece.id, moment.id)}>
                    ▶ Hear {piece.catalogue}, bars {moment.from}–{moment.to}
                  </a>
                ))}
                {paths.map((p) => (
                  <a key={p!.id} className="chip" href={`#path.${p!.id}`} style={{ background: 'var(--raised)' }}>
                    {named ? p!.name : 'The pattern behind it'} →
                  </a>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
